import React, { memo, useContext } from 'react'
import PropTypes from 'prop-types'

import { LanguageContext } from '../../../context/LanguageContext'
import { util } from '../../../util'

const Checkbox = ({
    label,
    labelClass,
    checked,
    onChange,
    margin,
    name,
    display,
    id,
    isPartial,
    isDisabled = false,
    isModified = false,
    className,
}) => {
    //RtL Support
    const { rtl } = useContext(LanguageContext)

    //Render
    return (
        <div
            className={util.joinClasses(
                'checkbox',
                margin,
                display,
                isModified && 'modified',
                className
            )}
        >
            <label className={util.joinClasses('checkbox__container')}>
                <input
                    className={'checkbox-input'}
                    name={name}
                    type={'checkbox'}
                    checked={checked}
                    onChange={onChange}
                    id={id}
                    disabled={isDisabled}
                />
                <span
                    className={util.joinClasses(
                        'checkmark',
                        isPartial && 'is-partial',
                        isDisabled && 'disable'
                    )}
                />
                <span className={`${labelClass} checkbox-label ${rtl && 'rtl'}`}>{label}</span>
            </label>
        </div>
    )
}

Checkbox.propTypes = {
    /** @param label {String} text which sits next to checkbox input */
    label: PropTypes.string,

    /** @param checked {Boolean} checked if true else unchecked false value */
    checked: PropTypes.bool,

    /** @param onChange {EventListener} event listener which to handle check input */
    onChange: PropTypes.func,

    /** @param margin {String} margin from the parent or adjacent child react element please check styles config file for different margins */
    margin: PropTypes.string,

    /** @param name {String} input name attribute */
    name: PropTypes.string,

    /** @param controls the css display property */
    display: PropTypes.oneOf(['block']),
}

export default memo(Checkbox)
